import { DescriptionText } from "../../styled";
import intl from "react-intl-universal";
import { InfoIcon } from "components/icons/icn-info.icon";
import { Content, Title } from "./styled";

interface UnconsideredInformationProps {
  caveats?: string[];
}

const UnconsideredInformation = (props: UnconsideredInformationProps) => {
  const { caveats } = props;

  if (!caveats || caveats.length === 0) return null;

  return (
    <Content>
      <Title>
        <InfoIcon width={16} height={16} color="#8A620A" aria-hidden="true" />
        <DescriptionText $fontWeight={700} $fontSize="0.688REM" color="#8A620A">
          {intl.get("stocks.suggestionContext.unconsideredInformation.title")}
        </DescriptionText>
      </Title>

      {caveats.map((caveat) => (
        <DescriptionText key={caveat} color="#0E0E0E">
          {caveat}
        </DescriptionText>
      ))}
    </Content>
  );
};

export default UnconsideredInformation;
